import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageInfoService } from '@metronic/layout';

@Component({
  selector: 'app-validate-qr-product-page',
  templateUrl: './validate-qr-product-page.component.html',
})
export class ValidateQrProductPageComponent implements OnInit {
  brandId: string;

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private pageInfoService: PageInfoService) {}

  ngOnInit(): void {
    this.getData();
    this.initPageInfo();
  }

  initPageInfo() {
    this.pageInfoService.updateTitle(`Validasi QR Biar tidak capek`, undefined, false);
  }

  getData() {
    this.activatedRoute.paramMap.subscribe((param) => {
      if (param?.get('id')) {
        this.brandId = param.get('id') ?? '';
      }
    });
  }

  backBtnClick() {
    this.router.navigate(['/products/detail/' + this.brandId]).then();
  }
}
